import React from 'react';
import { AssetState } from '../../types/asset';
import { CheckCircle2, Clock, Search, Database, AlertCircle } from 'lucide-react';

interface StatusBadgeProps {
  status: AssetState;
  size?: 'sm' | 'md';
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, size = 'md' }) => {
  const statusConfig = {
    [AssetState.INITIAL]: {
      label: 'Initial',
      icon: Clock,
      classes: 'bg-muted text-muted-foreground border-border',
    },
    [AssetState.IDENTIFIED]: {
      label: 'Identified',
      icon: Search,
      classes: 'bg-primary/10 text-primary border-primary/20',
    },
    [AssetState.REGISTERED]: {
      label: 'Registered',
      icon: Database,
      classes: 'bg-secondary/10 text-secondary border-secondary/20',
    },
    [AssetState.INGESTED]: {
      label: 'Ingested',
      icon: CheckCircle2,
      classes: 'bg-primary/10 text-primary border-primary/20',
    },
    [AssetState.ERROR]: {
      label: 'Error',
      icon: AlertCircle,
      classes: 'bg-destructive/10 text-destructive border-destructive/20',
    },
  };

  const { label, icon: Icon, classes } = statusConfig[status];
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  return (
    <span className={`inline-flex items-center gap-1.5 font-medium border rounded-full ${classes} ${sizeClasses}`}>
      <Icon className={size === 'sm' ? 'w-3 h-3' : 'w-4 h-4'} />
      {label}
    </span>
  );
};
